export default function KeyValueRenderer({ section, renderValue }) {

    return (

        <div className="section-body">

            {Object.entries(section.fields || {}).map(([k, field])=>(

                <div className="section-row" key={k}>

                    <span className="section-label">
                        {field.label}
                    </span>

                    <span className="section-value">
                        {renderValue(field)}
                    </span>

                </div>

            ))}

        </div>

    );

}